import { HAMMER_GESTURE_CONFIG, HammerGestureConfig } from '@angular/platform-browser';
import { NgModule, Injectable } from '@angular/core';
import { NavbarComponent } from '../navbar/navbar.component';
import { RouterModule } from '@angular/router';
import { FooterComponent } from '../footer/footer.component';
import { WebAppComponent } from './web-app.component';
import { webAppRoutes } from './web-app-routing';
import { CommonModule } from '@angular/common';
import { BsDropdownConfig, BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CookieService } from 'ngx-cookie-service';
import { CookiesEditModalModule } from '../../shared/components/cookies-edit-modal/cookies-edit-modal.module';
import { CookiesModule } from '../cookies/cookies.module';
import {MAT_DIALOG_DEFAULT_OPTIONS} from "@angular/material/dialog";

@Injectable()
export class CustomHammerConfig extends HammerGestureConfig {
  overrides = {
    pinch: { enable: false },
    rotate: { enable: false }
  };
}

@NgModule({
    declarations: [
        NavbarComponent,
        FooterComponent,
        WebAppComponent
    ],
    imports: [
        CommonModule,
        RouterModule.forChild(webAppRoutes),
        BsDropdownModule.forRoot(),
        CookiesEditModalModule,
        CookiesModule,
    ],
    providers: [
        { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: true } },
        { provide: HAMMER_GESTURE_CONFIG, useClass: CustomHammerConfig },
        BsDropdownConfig,
        CookieService,
    ],
    exports: [
        NavbarComponent,
        FooterComponent,
    ]
})
export class WebAppModule {
}
